import { PropsWithChildren } from 'react';

export interface CellProps extends PropsWithChildren {
  isActionalble?: boolean;
  style?: React.CSSProperties;
}

const Cell: React.FC<CellProps> = ({ isActionalble = true, children, style }) => {
  return <div style={style}>{children}</div>;
};

export default Cell;
